import { Component } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { ApiUrlHelper } from 'src/app/common/apiUrlHelper';
import { CommonConstant } from 'src/app/constants/common-constant';
import { UserConstant } from 'src/app/constants/label-constants';
import { CommonService } from 'src/app/services/common/common.service';
@Component({
  selector: 'app-user-view',
  templateUrl: './user-view.component.html',
  styleUrls: ['./user-view.component.scss']
})
export class UserViewComponent {
  UserForm: FormGroup = this.formBuilder.group({});
  AdminRoleList: any = [];
  userId: number = 0;
  commonConstant: any = [];
  flag: boolean = false;
  userConstant: any = [];

  constructor(
    private CommonService: CommonService,
    private formBuilder: FormBuilder,
    private apiUrl: ApiUrlHelper,
    private spinner: NgxSpinnerService,
    public modalService: NgbActiveModal,
  ) { }

  ngOnInit(): void {
    this.spinner.show();
    this.commonConstant = CommonConstant;
    this.getUserDetail(this.userId);
    //  this.getAdminRoleList();
    this.userConstant = UserConstant;
  }

  getUserDetail(userId: number) {
    const apiUrl = this.apiUrl.apiUrl.user.GetUserById.replace("{id}", userId.toString());
    this.CommonService.doGet(apiUrl).pipe().subscribe({
      next: (data) => {
        this.AdminRoleList = data.data[0];
        this.spinner.hide();
        this.flag = true;
      },
      error: (err) => {
        console.log('getGetUserById-Error', err);
      }
    });
  }


}
